module.exports = __webpack_public_path__ + "img/fruit-papaya-190x100.04edc505.jpg";